"use client";

import Link from "next/link";

import { NAV_INK_FOCUS_RING } from "@/components/nav/nav-styles";
import WorkspaceSwitcher, {
  WorkspaceLogo,
} from "@/components/nav/WorkspaceSwitcher";
import { cn } from "@/lib/utils";

const HOME_LINK = cn(
  "flex items-center rounded-lg px-2 py-1 transition-colors hover:bg-white/5",
  NAV_INK_FOCUS_RING,
);

/**
 * The studio's mark at the left of the navy top bar (NavTopBar): the full
 * logo, whatever is open beside the rail. For someone who can switch studios
 * it is the switcher's trigger (`WorkspaceSwitcher`), otherwise a link home;
 * either way it is its own name.
 */
export default function StudioBand({ displayName, displayLogo, switcher }) {
  return (
    <div className="flex min-w-0 shrink-0 items-center">
      {switcher ? (
        <WorkspaceSwitcher {...switcher} />
      ) : (
        <Link href="/" className={HOME_LINK}>
          <WorkspaceLogo workspace={{ name: displayName, image: displayLogo }} ink />
        </Link>
      )}
    </div>
  );
}
